import { Component, OnInit } from '@angular/core';
import { ListaMovilesService } from 'src/app/shared/services/lista-moviles.service';
import { Gtp } from 'src/app/shared/gtp';

@Component({
  selector: 'app-lista-posiciones',
  templateUrl: './lista-recorrido-posiciones.component.html',
  styleUrls: ['./lista-recorrido-posiciones.component.scss'],
})
export class ListaRecorridoPosicionesComponent implements OnInit {

  resumenListado:any = [];

  constructor(
    public listamovilesservice: ListaMovilesService,
    public gtp: Gtp,
  ) { }

  ngOnInit(): void {
    this.loadData();
  }

  loadData(){
    this.resumenListado = (this.listamovilesservice.resumenListado).recorrido;
    this.listamovilesservice.getResumenRecorrido().subscribe(data => {
      //console.log(data.recorrido)
      this.resumenListado = data.recorrido;
    });
  }

  showPosition(i){
    //console.log(i)
    this.listamovilesservice.setPositionRecorrido(i);
  }

  changeTab(){
    this.listamovilesservice.sideResumen('eventos');
  }

}
